import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Text from '@raydiant/raydial/components/Text';
import FreeTrialExpiredImg from './free-trial-expired.svg';
import Button from '@raydiant/raydial/components/Button';

interface FreeTrialExpiredDialogProps {
  isOpen: boolean;
  onSubscribe: () => void;
  onClose: () => void;
}

const FreeTrialExpiredDialog = ({
  isOpen,
  onSubscribe,
  onClose,
}: FreeTrialExpiredDialogProps) => {
  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog className="grid relative" onClose={onClose}>
        <DialogHeader>
          <DialogHeading>Unlock all the power of Displai!</DialogHeading>
        </DialogHeader>
        <div className="flex flex-col items-center px-4">
          <img
            src={FreeTrialExpiredImg}
            alt="free trial expired"
            className="w-[274px] aspect-[1.028] mb-8"
          />
          <Text className="text-center text-2xl md:text-3xl font-semibold">
            Looks like your trial expired, subscribe now to continue where you
            left off!
          </Text>
          <Text className="mt-6 md:mt-10">
            Don’t worry, all your content is still waiting for you. Subscribe
            now and continue to Displai brilliance on all of your screens!
          </Text>
        </div>
        <footer className="flex flex-wrap gap-6 pb-4 px-4 mt-8">
          <Button
            size="large"
            variant="primary"
            className="grow"
            onPress={onSubscribe}
          >
            Subscribe Now
          </Button>
        </footer>
      </Dialog>
    </Modal>
  );
};

export default FreeTrialExpiredDialog;
